// External libraries
import gql from 'graphql-tag';

export const UPGRADE_GUEST_TO_MEMBER_MUTATION = gql`
  mutation UpgradeGuestToMemberMutation(
    $billingAddress: AddressInput
    $contentIdentifier: String
    $country: CountryCodes
    $dateOfBirth: DateOfBirth
    $email: String!
    $firstName: String!
    $gender: Gender
    $identityDocument: IdentityDocumentInput
    $lastName: String!
    $marketingOptOut: Boolean
    $nationality: CountryCodes
    $occupation: Occupation
    $password: String
    $phone: PhoneInput!
    $placeOfBirth: CountryCodes
    $secondaryIdentityDocument: IdentityDocumentInput
    $token: String!
    $residentialAddress: AddressInput
    $legalAgreements: LegalAgreementsInput
  ) {
    upgradeGuestToMember(
      billingAddress: $billingAddress
      contentIdentifier: $contentIdentifier
      country: $country
      dateOfBirth: $dateOfBirth
      email: $email
      firstName: $firstName
      gender: $gender
      identityDocument: $identityDocument
      lastName: $lastName
      marketingOptOut: $marketingOptOut
      nationality: $nationality
      occupation: $occupation
      password: $password
      phone: $phone
      placeOfBirth: $placeOfBirth
      secondaryIdentityDocument: $secondaryIdentityDocument
      token: $token
      residentialAddress: $residentialAddress
      legalAgreements: $legalAgreements
    ) {
      buyer {
        auth {
          accessToken
        }
        userId
      }
    }
  }
`;
